import { FolderPlus, Loader2, Plus, Upload } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface ProjectDocumentAddMenuProps {
  isUploading: boolean;
  onCreateFolder: () => void;
  onUploadDocuments: () => void;
}

export function ProjectDocumentAddMenu({
  isUploading,
  onCreateFolder,
  onUploadDocuments,
}: ProjectDocumentAddMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="icon-sm" aria-label="Add to document library">
          {isUploading ? <Loader2 className="size-4 animate-spin" /> : <Plus className="size-4" />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onSelect={(event) => {
            event.preventDefault();
            onCreateFolder();
          }}
        >
          <FolderPlus className="size-4" />
          Create folder
        </DropdownMenuItem>
        <DropdownMenuItem
          onSelect={(event) => {
            event.preventDefault();
            onUploadDocuments();
          }}
        >
          <Upload className="size-4" />
          Upload docs
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
